import api from "../../lib/api";

const apiRoute = `/api/agencies/`;

export const fetchAgencies = () => (dispatch) => {
  return api
    .get(`${apiRoute}`)
    .then((agencies) => {
      dispatch({
        type: "SET_AGENCIES",
        payload: agencies.data.data,
      });
    })
    .catch((err) => err);
};
